import {Number, PositiveNumber, PositiveIntegerNumber, IntegerNumber} from './components/Number';
import {
    CustomNumber,
    CustomPositiveNumber,
    CustomPositiveIntegerNumber,
    CustomIntegerNumber
} from "./components/CustomNumber";
import {
    Popover,
    PopoverInteger,
    PopoverPositive,
    PopoverZeroPositive,
    PopoverPositiveInteger,
} from './components/PopoverNumber';

import {ContentNumber} from "./components/ContentNumber";

export default {
    ContentNumber,
    Number,
    PositiveNumber,
    PositiveIntegerNumber,
    IntegerNumber,
    CustomNumber,
    CustomPositiveNumber,
    CustomPositiveIntegerNumber,
    CustomIntegerNumber,
    Popover,
    PopoverInteger,
    PopoverPositive,
    PopoverZeroPositive,
    PopoverPositiveInteger,
};



// WEBPACK FOOTER //
// ./src/view/component/lib/react-numpad/index.js